<template>
  <div id="about">
      <h3>About MealTrips</h3>
      <span>Let’s make a little introduction &#128522;</span>

      <p>
          MealTrips Foods is a food ordering/delivery service app (presently available on android) that stands as a bridge between our customers and their favourite restaurants.<br>
          We make food ordering and delivery easy and smooth as possible at the cheapest rate ever.
      </p>
      <a href="https://play.google.com/store/apps/details?id=com.ccr.mealtrips" target="_blank"><button class="get">Get the App</button></a>
      <img src="../assets/phone.png" alt="Mealtrips app" class="phone">
  </div>
</template>

<script>
export default {
    name: 'About'
}
</script>

<style lang="scss" scoped>

#about{
    display: flex;
    flex-direction: column;
    align-content: center;
    height: auto;
    background: url('../assets/svg/about.svg');
    background-size: cover;
    text-align: center;
    padding: 112px 8%;
    font-family: 'Raleway', sans-serif;
    a:hover{
        text-decoration: none;
    }
    h3{
        font-size: 36px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 24px;
        font-weight: 300;
        color: #13232A;
    }
    p{
        width: 50%;
        text-align: left;
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 44px;
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: auto;
    }
    .phone{
        width: 452.3px;
        margin: auto;
        margin-top: 40px;
    }
}

@media (max-width:480px) {
    #about{
    display: flex;
    flex-direction: column;
    align-content: center;
    height: auto;
    background: url('../assets/svg/about.svg');
    background-size: cover;
    text-align: center;
    padding: 112px 8%;
    font-family: 'Raleway', sans-serif;
    // margin-top: -8%;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 18px;
        width: 100%;
        text-align: center;
        font-weight: 300;
        color: #13232A;
    }
    p{
        width: 80%;
        text-align: left;
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 20px;
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: 20px auto;
    }
    .phone{
        width: 200px;
        height: 200px;
        margin: 0 auto;
        margin-top: 40px;
    }
}
}

@media (min-width: 481px) and (max-width: 768px) {
    #about{
    display: flex;
    flex-direction: column;
    align-content: center;
    height: auto;
    background: url('../assets/svg/about.svg');
    background-size: cover;
    text-align: center;
    padding: 112px 8%;
    font-family: 'Raleway', sans-serif;
    // margin-top: -8%;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 18px;
        text-align: center;
        font-weight: 300;
        color: #13232A;
    }
    p{
        width: 80%;
        text-align: left;
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 20px;
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: 20px auto;
    }
    .phone{
        width: 270px;
        height: 270px;
        margin: 0 auto;
        margin-top: 40px;
    }
}
}

@media (min-width: 769px) and (max-width: 1024px) {
    #about{
    display: flex;
    flex-direction: column;
    align-content: center;
    height: auto;
    background: url('../assets/svg/about.svg');
    background-size: cover;
    text-align: center;
    padding: 112px 8%;
    font-family: 'Raleway', sans-serif;
    // margin-top: -8%;
    h3{
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        text-align: center;
        font-weight: 300;
        color: #13232A;
    }
    p{
        width: 80%;
        text-align: left;
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 20px;
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: 20px auto;
    }
    .phone{
        width: 350px;
        height: 350px;
        margin: 0 auto;
        margin-top: 40px;
    }
}
}
</style>